"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtpType = void 0;
var OtpType;
(function (OtpType) {
    OtpType["EMAIL"] = "EMAIL";
    OtpType["PASSWORD"] = "PASSWORD";
    OtpType["INVITE"] = "INVITE";
})(OtpType || (exports.OtpType = OtpType = {}));
//# sourceMappingURL=otp.js.map